import React, { useEffect, useState } from "react";
import ReactTooltip from 'react-tooltip';
import {
  screen,
  header,
  headerContent,
  headerUsername,
  headerDesc,
  headerAvatar,
  postItem,
  postSide,
  postContent,
  postHeader,
  postTitle,
  postIcon,
  postDate,
  postBody,
  vertLine,
  dateDivider,
  month,
  link,
  footer,
  linkImage,
  linkPreview
} from "./feed.module.css";

import gitIcon from "./images/github.svg";
import liIcon from "./images/linkedin.svg";





const Feed = () => {

  const [posts, setPosts] = useState({});
  
  useEffect(() => {
    fetch("https://api.airtable.com/v0/app3pZdVMW2Gc3QCg/Table%201?sort%5B0%5D%5Bfield%5D=Date&sort%5B0%5D%5Bdirection%5D=desc&api_key=keyRNA9mMOfisGQ66")
      .then((res) => res.json())
      .then((data) => {
        setPosts(data.records);
        console.log(data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  return (

    <div className={screen}>
        <ReactTooltip className="tooltip"/>

      <div className={header}>
        {/* <div className={headerAvatar}>
          <img src="https://images.unsplash.com/photo-1534278931827-8a259344abe7?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2370&q=80"></img>
        </div> */}
        <div className={headerContent}>
          <div className={headerUsername}>be merry :)</div>
          <div className={headerDesc}>
            <a
              className={link}
              data-tip="click to copy"
              onClick={() =>  navigator.clipboard.writeText("mary.jiang@duke.edu")}
              >
                mary.jiang@duke.edu
            </a>
            <br></br>
            
            
            <a className={link} target="_blank" href="https://drive.google.com/file/d/1clYt2rWr2QyrJ7nxqWUPQoYlyJawKyGs/view?usp=sharing">resume</a>
            *
            <a className={link} target="_blank" href="https://github.com/merryvj">github</a>

            {/* <a className={icon} href="#"> <img src={gitIcon}></img></a>
            <a className={icon} href="#"> <img src={liIcon}></img></a> */}
          </div>

        </div>
      </div>

      <hr></hr>
      {posts.length > 0 ? (
      posts.map((post) => (
        <div key={post.id} className={postItem}>
          <div className={postSide}>
            <div className={vertLine}></div>

            <div className={postIcon}>{post.fields.Icon}</div>
          </div>
          <div className={postContent}>
            <div className={postHeader}>
              <div className={postTitle}> {post.fields.Title}</div>
            </div>
            <div className={postBody}>{post.fields.Body}
            </div>
            {post.fields.Image ? 
            
              <a target="_blank" href={post.fields.Link} className={linkPreview}>
                  <img className={linkImage}
                src={post.fields.Image[0].thumbnails.large.url}
                alt="view project"
                
                />
              </a>
              : null
            } 

            


          </div>
        </div>
      ))
    ) : (
      <></>
    )}
     
      <hr></hr>
      <div className={footer}>
        Have a great day 
      </div>
        
    </div>
  );
};

export default Feed;
